import React from 'react';
import { CCard, CCardBody, CCol, CRow } from '@coreui/react';
import Detail from '../../components/micro/Detail';
import _t from 'counterpart';
import { useQuery } from 'react-query';
import { getPersonalInfo, getTraderQuestionnaire } from '../../services/BackendService';
import CenteredSpinner from '../../components/CenteredSpinner';
import { formatDateTime } from '../../helpers';

export const TraderQuestionnaireTab = ({ customerId }: { customerId: string }) => {
  const traderQuestionnaireQuery = useQuery(['trader-questionnaire', customerId], () =>
    getTraderQuestionnaire(customerId)
  );

  const traderQuestionnaire = traderQuestionnaireQuery.data;
  if (traderQuestionnaireQuery.isLoading) {
    return <CenteredSpinner />;
  }
  return (
    <CCard>
      <CCardBody>
        <CRow>
          <CCol md={6}>
            <dl>
              <Detail title={_t('customer.questionnaire.employment')}>{traderQuestionnaire?.employment || '-'}</Detail>
              <Detail title={_t('customer.questionnaire.experience')}>{traderQuestionnaire?.experience || '-'}</Detail>
            </dl>
          </CCol>
          <CCol md={6}>
            <dl>
              <Detail title={_t('customer.questionnaire.net-worth')}>
                {traderQuestionnaire?.netWorth ? traderQuestionnaire.netWorth : '-'}
              </Detail>
              <Detail title={_t('customer.questionnaire.result')}>{traderQuestionnaire?.result || '-'}</Detail>
              <Detail title={_t('customer.questionnaire.terms-accepted')}>
                {traderQuestionnaire?.termsAcceptedAt ? formatDateTime(traderQuestionnaire.termsAcceptedAt) : '-'}
              </Detail>
            </dl>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  );
};
